import { noticeError } from "@src/helpers/monitoring";

export const handleDownloadApp = ({
  osPlatform,
  appDownloadUrl,
  trackingCallback
}) => {
  trackingCallback && trackingCallback(osPlatform);
  try {
    window.location.assign(appDownloadUrl);
  } catch (error) {
    noticeError("Failed to navigate to app URL, opening in new tab", error);
    window.open(appDownloadUrl, "_blank");
  }
};
